import DonutTooltip from "components/DonutTooltip";
import Flex from "components/Flex";
import { arrayOf, number, oneOfType, shape, string } from "prop-types";
import React from "react";
import { Doughnut } from "react-chartjs-2";

import styles from "./ArchivedOpportunitiesByReason.module.scss";
import { useArchivedOpportunitiesByReasonChart } from "./useArchivedOpportunitiesByReasonChart";

const ArchivedOpportunitiesByReasonDonut = ({
  reasons,
  totalArchivedCount,
  wrapperClassName = styles.archivedOpportunitiesByReason__donutWrapper,
}) => {
  const { chartData, chartOptions, tooltipRef, titleRef, bodyRef } =
    useArchivedOpportunitiesByReasonChart(reasons, totalArchivedCount);

  return (
    <Flex
      className={styles.archivedOpportunitiesByReason__donutWrap}
      justifyContent="center"
    >
      <div className={wrapperClassName}>
        <Doughnut data={chartData} options={chartOptions} />
        <div className={styles.archivedOpportunitiesByReason__donutCenter}>
          <span className={styles.archivedOpportunitiesByReason__donutCount}>
            {totalArchivedCount}
          </span>
          <span className={styles.archivedOpportunitiesByReason__donutLabel}>
            Archived
          </span>
        </div>
      </div>
      <DonutTooltip tooltipRef={tooltipRef} titleRef={titleRef} bodyRef={bodyRef} />
    </Flex>
  );
};

ArchivedOpportunitiesByReasonDonut.propTypes = {
  reasons: arrayOf(
    shape({
      statusId: oneOfType([number, string]),
      statusName: string.isRequired,
      count: number.isRequired,
    })
  ).isRequired,
  totalArchivedCount: number.isRequired,
  wrapperClassName: string,
};

export default ArchivedOpportunitiesByReasonDonut;
